import React from "react";
import homeStyle from "./styles";
import {
  Avatar,
  Box,
  Typography,
  Button,
  List,
  ListItem,
  Link,
} from "@mui/material";
import { useRouter } from "next/router";
const JoinCommunity = () => {
  const router = useRouter();
  const handleGoCommunity = () => {
    router.push("/community");
  };
  return (
    <Box sx={homeStyle.communitySection}>
      <Box sx={homeStyle.communityHeading}>
        <Typography variant="h1" sx={homeStyle.communityTitle}>
          Join the Community
        </Typography>
      </Box>
      <Box sx={homeStyle.communityImgContainer}>
        <Box sx={homeStyle.communityBox}>
          <Box sx={homeStyle.followerBox}>
            <Box sx={homeStyle.lockedUser}>
              <Box
                component="img"
                src="./images/home/user-img.svg"
                width="42px"
                height="42px"
              />
            </Box>
            <Box>
              <Typography variant="h5">FanTiger</Typography>
              {/* <Typography component="p">291 Members</Typography> */}
            </Box>
            <Link href="/community/624566343379a7ea6c377a71/624578e230977b263c6cf47c">
              View All
            </Link>
          </Box>
          <Box
            component="img"
            sx={homeStyle.communityBoxImg}
            src="./images/home/image1.png"
            alt=""
          />
        </Box>
        <Box sx={homeStyle.communityBox}>
          <Box sx={homeStyle.followerBox}>
            <Box sx={homeStyle.lockedUser}>
              <Box
                component="img"
                src="./images/home/punjabi-music-user.png"
                width="42px"
                height="42px"
              />
            </Box>
            <Box>
              <Typography variant="h5">Punjabi Music</Typography>
              {/* <Typography component="p">2,291 Members</Typography> */}
            </Box>
            <Link href="/community/624569733379a7ea6c377a76/62457be830977b263c6cf4d5">
              View All
            </Link>
          </Box>
          <Box
            component="img"
            sx={homeStyle.communityBoxImg}
            src="./images/home/image2.png"
            alt=""
          />
        </Box>
        <Box sx={homeStyle.communityBox}>
          <Box sx={homeStyle.followerBox}>
            <Box sx={homeStyle.lockedUser}>
              <Box
                component="img"
                src="./images/home/nft-holder.png"
                width="42px"
                height="42px"
              />
              <Typography component="span">
                <Box component="img" src="./images/home/lock.svg" />
              </Typography>
            </Box>
            <Box>
              <Typography variant="h5">NFT Holder</Typography>
              <Typography component="p"></Typography>
            </Box>
            <Link href="/community">View All</Link>
          </Box>
          <Box
            component="img"
            sx={homeStyle.communityBoxImg}
            src="./images/home/image3.png"
            alt=""
            onClick={() => router.push("/nft/9-9-mashukan")}
            style={{ cursor: "pointer" }}
          />
          <Box
            sx={homeStyle.communityJoinSection}
            onClick={handleGoCommunity}
            style={{ cursor: "pointer" }}
          >
            <Box>
              <Typography sx={homeStyle.communityChHeading} variant="h1">
                1,243
              </Typography>
              <Typography component="p">
                Members are talking right now
              </Typography>
              <Box
                component="img"
                src="./images/home/community-glow.png"
                alt=""
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box sx={homeStyle.communityExplore}>
        <Button
          variant="outlined"
          sx={homeStyle.CommunityBtnExplore}
          onClick={handleGoCommunity}
        >
          Explore More
        </Button>
      </Box>
    </Box>
  );
};

export default JoinCommunity;
